// Importing React and external libs
import React from 'react';
import PropTypes from 'prop-types';

// Importing antd libs
import { Button, Popconfirm } from 'antd';
import 'antd/es/button/style/css';
import 'antd/es/popconfirm/style/css';

// Importing antd icons
import { DeleteOutlined } from '@ant-design/icons';

// Importing helix hooks
import useLanguage from 'helix-hooks/language';

// Importing component style
import './style.scss';

const BtnConfirm = (props) => {
  // Loading component language
  const Language = useLanguage();
  const { context, danger, disabled, icon, name, onConfirm, ...restProps } = props;
  return (
    <div className="btn-confirm-wrapper">
      <Popconfirm
        disabled={disabled}
        title={Language.get(context, 'CONFIRM_DELETION')}
        onConfirm={onConfirm}
        okText={Language.get(context, 'YES')}
        cancelText={Language.get(context, 'NO')}
      >
        <Button
          className="icon"
          danger={danger}
          disabled={disabled}
          icon={icon}
          size="small"
          {...restProps}
        >
          {name || ''}
        </Button>
      </Popconfirm>
    </div>
  );
};

BtnConfirm.propTypes = {
  context: PropTypes.string,
  danger: PropTypes.bool,
  icon: PropTypes.object,
  onConfirm: PropTypes.func,
};

BtnConfirm.defaultProps = {
  context: 'common',
  danger: true,
  icon: <DeleteOutlined />,
};

export default BtnConfirm;
